import React, { useState } from "react";
import { Card, CardContent, Container, Divider, Step, StepLabel, Stepper } from "@mui/material";
import { Redeem, Search, CheckCircle } from "@mui/icons-material";
import belezaApi from "../../services/BelezaService";
import { Button, Grid, ResultAlert, Stack, TextField, Typography, moeda, Paper } from "../Beleza/shared";

const steps = ["Identificar voucher", "Confirmar dados", "Ativar presente"];

const BelezaValePresentePublic = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [codigo, setCodigo] = useState("");
  const [vale, setVale] = useState(null);
  const [form, setForm] = useState({ nome: "", telefone: "", whatsApp: "", email: "" });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const validar = async () => {
    setError(""); setSuccess(""); setLoading(true);
    try {
      const resp = await belezaApi.valesPresente.validarPublico({ codigo });
      setVale(resp?.data || resp);
      setActiveStep(1);
    } catch (err) {
      setError(err?.response?.data?.message || err.message || "Voucher inválido.");
    } finally { setLoading(false); }
  };

  const ativar = async () => {
    setError(""); setSuccess(""); setLoading(true);
    try {
      await belezaApi.valesPresente.ativarPublico({ codigo, ...form });
      setSuccess("Vale-presente ativado com sucesso. Entre em contato para agendar seu atendimento.");
      setActiveStep(2);
    } catch (err) {
      setError(err?.response?.data?.message || err.message || "Não foi possível ativar o voucher.");
    } finally { setLoading(false); }
  };

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 2, md: 6 } }}>
      <Card sx={{ borderRadius: 4, overflow: "hidden", boxShadow: "0 24px 80px rgba(15,23,42,.18)" }}>
        <BoxHeader />
        <CardContent sx={{ p: { xs: 2, md: 3 } }}>
          <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 2 }}>
            {steps.map((label) => <Step key={label}><StepLabel>{label}</StepLabel></Step>)}
          </Stepper>
          <ResultAlert error={error} success={success} />
          {activeStep === 0 && <Stack spacing={2}>
            <TextField label="Código do voucher" value={codigo} onChange={(e) => setCodigo(e.target.value.toUpperCase())} fullWidth />
            <Button variant="contained" startIcon={<Search />} onClick={validar} disabled={loading || !codigo}>Validar voucher</Button>
          </Stack>}
          {activeStep === 1 && <Stack spacing={2}>
            <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
              <Typography variant="h6" fontWeight={900}>{vale?.nome}</Typography>
              <Typography color="text.secondary">{vale?.descricao}</Typography>
              <Divider sx={{ my: 1 }} />
              <Typography fontWeight={900}>Valor: {moeda(vale?.valor)}</Typography>
            </Paper>
            <Grid container spacing={1.5}>
              <Grid item xs={12}><TextField fullWidth label="Seu nome" value={form.nome} onChange={(e) => setForm((p) => ({ ...p, nome: e.target.value }))} /></Grid>
              <Grid item xs={12} sm={6}><TextField fullWidth label="Celular" value={form.telefone} onChange={(e) => setForm((p) => ({ ...p, telefone: e.target.value }))} /></Grid>
              <Grid item xs={12} sm={6}><TextField fullWidth label="WhatsApp" value={form.whatsApp} onChange={(e) => setForm((p) => ({ ...p, whatsApp: e.target.value }))} /></Grid>
              <Grid item xs={12}><TextField fullWidth label="E-mail" value={form.email} onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))} /></Grid>
            </Grid>
            <Button variant="contained" startIcon={<CheckCircle />} onClick={ativar} disabled={loading || !form.nome}>Ativar vale-presente</Button>
          </Stack>}
          {activeStep === 2 && <Stack spacing={2} alignItems="center" textAlign="center" py={2}>
            <CheckCircle color="success" sx={{ fontSize: 64 }} />
            <Typography variant="h5" fontWeight={900}>Presente ativado</Typography>
            <Typography color="text.secondary">Seu voucher foi vinculado ao cadastro informado.</Typography>
          </Stack>}
        </CardContent>
      </Card>
    </Container>
  );
};

const BoxHeader = () => (
  <Stack alignItems="center" spacing={1} sx={{ p: 3, color: "white", background: "linear-gradient(135deg,#111827,#7c3aed)" }}>
    <Redeem sx={{ fontSize: 52 }} />
    <Typography variant="h4" fontWeight={950}>Vale-presente</Typography>
    <Typography textAlign="center">Ative seu presente e agende sua experiência.</Typography>
  </Stack>
);

export default BelezaValePresentePublic;
